import React from 'react';
import { useTheme } from "./ThemeContext";
import { Link } from 'react-router-dom';



export default function Footer() {
    const { darkMode } = useTheme();
    return(
        <footer className={`${darkMode ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-600'} py-6`} style={{position:"relative",bottom:0,width:"100%"}}>
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p>&copy; 2025 WebUtility. All rights reserved.</p>
            </div>
            <div className="flex space-x-4">
              <Link to={'/privacy'} className="hover:text-blue-500 transition-colors">Privacy</Link>
              <a href="./terms" className="hover:text-blue-500 transition-colors">Terms</a>
              <a href="./contact" className="hover:text-blue-500 transition-colors">Contact</a>
            </div>
          </div>
        </div>
      </footer>
    )
}